import { Translations } from '../types';

export default {
  home: {
    title: 'WebClip',
    subtitle: '安全、即时的跨设备剪贴板共享工具',
    tagline: '端到端加密 · 无需注册 · 自动过期',
    createButton: '创建安全剪贴板',
    creating: '创建中...',
    features: {
      encryption: { title: '端到端加密', desc: '数据在浏览器中加密后传输，服务器无法解密' },
      zeroKnowledge: { title: '零知识架构', desc: '服务器无法访问您的内容，PIN码永不离开浏览器' },
      realtime: { title: '即时同步', desc: '所有连接设备实时同步，支持文本和图片' },
    },
    footer: '数据将在24小时后自动过期清除',
  },
  clip: {
    title: 'WebClip',
    loading: '加载中...',
    notFound: '剪贴板不存在或已过期',
    notFoundDesc: '此剪贴板可能已过期或不存在',
    backToHome: '返回首页',
    enterPin: '输入 PIN 码',
    pinHint: '输入6位字符 PIN 码访问此安全剪贴板',
    lockoutWarning: '3次失败将锁定60秒',
    connected: '已连接',
    connecting: '连接中...',
    encrypted: '已加密',
    connectedStatus: '已连接',
  },
  shareBar: {
    copyUrl: '复制链接',
    showQR: '显示二维码',
    hideQR: '隐藏二维码',
    pin: 'PIN:',
    showPin: '显示 PIN',
    hidePin: '隐藏 PIN',
    copyPin: '复制 PIN',
    connections: '个连接',
    connected: '已连接',
  },
  messageList: {
    empty: '暂无消息',
    emptyHint: '分享链接和 PIN 码开始聊天',
    failedToLoad: '加载图片失败',
    noImageData: '无图片数据',
    copy: '复制',
    close: '关闭',
    closeEsc: '关闭 (Esc)',
    clickToEnlarge: '点击放大',
    receiving: '接收中... {{percent}}%',
    download: '下载',
  },
  inputBar: {
    placeholder: '输入消息...',
    connecting: '连接中...',
    send: '发送',
    uploadImage: '上传图片',
    uploadVideo: '上传视频',
    fileTooLarge: '文件过大 (最大 100MB)',
    imageTooLarge: '图片太大，已自动压缩但仍超过 1MB 限制',
    failedToSend: '发送失败',
    uploading: '上传中... {{percent}}%',
  },
  language: {
    switch: '切换语言',
    zh: '中文',
    en: 'English',
  },
  common: {
    error: '错误',
    retry: '重试',
    copied: '已复制',
    copy: '复制',
  },
  pwa: {
    install: {
      title: '安装 WebClip 应用',
      description: '添加到主屏幕，快速访问安全剪贴板',
      iosTitle: '添加到主屏幕',
      iosDescription: '点击分享按钮，然后选择"添加到主屏幕"',
      installButton: '安装',
      laterButton: '稍后',
    },
  },
} satisfies Translations;
